import type { TagProps } from '@interco/inter-toranja/dist/types/shared'
import { BridgeService } from '@/services'

export function requestAnalyticsFromToranjaTag(
  tag: TagProps,
  screenName: string,
  cardTitle: string,
): void {
  if (!screenName) return

  const result = tag({
    screen_name: screenName,
    title: cardTitle,
  }) as AnalyticsEvent

  const eventName = result.name
  if (typeof eventName !== 'string') {
    return
  }

  const c = result.ComponentProperties

  BridgeService.requestAnalytics(eventName, {
    screen_name: result.screen_name,
    component_name: c.component_name,
    title: result.title,
    label: c.label,
    state: c.state,
    variant: c.variant,
    size: c.size,
    hierarchy: c.hierarchy,
    show_leading_icon: String(c.show_leading_icon),
    leading_icon: c.leading_icon,
    leading_variant: c.leading_variant,
    paragraph: c.paragraph,
    paragraph_support: c.paragraph_support,
    tag_label: c.tag_label,
    tag_trailing_label: String(c.tag_trailing_label),
    trailing_variant: c.trailing_variant,
  }).catch(() => {
    /* evita rejeição não tratada no webview */
  })
}
